<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <h5>Asistente para el registro de Citas</h5>

    <!-- Encabezado del paso con tipo de ingreso -->
    <div style="display:flex; justify-content:space-between; align-items:center;
                background-color:#f0f0f0; padding:10px; border-radius:5px;">
      <h4 class="mb-0">Paso 1: Datos de la persona</h4>

      <div class="d-flex align-items-center gap-3">
        <span class="fw-semibold text-secondary" style="font-size:0.9rem;">Tipo de ingreso:</span>
        <div class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="radio"
                 id="tipoAgendamiento" name="tipoIngreso"
                 value="Agendamiento"
                 v-model="tipoIngreso">
          <label class="form-check-label" for="tipoAgendamiento">Agendamiento</label>
        </div>
        <div class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="radio"
                 id="tipoAdmision" name="tipoIngreso"
                 value="Admisión"
                 v-model="tipoIngreso">
          <label class="form-check-label" for="tipoAdmision">Admisión</label>
        </div>
      </div>
    </div>

    <hr>

    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body form-card">
          <div class="row">
            <!-- Columna de la imagen -->
            <div class="col-md-3">
              <img src="../../assets/images/wizardCita/paciente_cita_01.png"
                   alt="Imagen" :style="estiloImagen" />
            </div>
            <!-- Columna del formulario -->
            <div class="col-md-9">
              <form>
                <div class="modal-body">

                  <div class="mb-3" v-if="btnEditar">
                    <div class="row">
                      <div class="col-2">
                        <label for="idPersona" class="form-label">IdPersona</label>
                      </div>
                      <div class="col-10">
                        <input type="text" class="form-control" id="idPersona"
                               name="idPersona" v-model="datoPersona.idPersona" disabled>
                      </div>
                    </div>
                  </div>

                  <!-- Tipo Id. / Documento -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="idTipoIden" class="form-label">Tipo Id.</label>
                      </div>
                      <div class="col-4">
                        <select class="form-select" id="idTipoIden" name="idTipoIden"
                                v-model="datoPersona.idTipoIden" @change="handleChange01">
                          <option v-for="tipoIden in tiposIden"
                                  :key="tipoIden.idTipoIden"
                                  :value="tipoIden.idTipoIden">
                            {{ tipoIden.nombre }}
                          </option>
                        </select>
                      </div>
                      <div class="col-2">
                        <label for="documento" class="form-label">Documento</label>
                      </div>
                      <div class="col-3">
                        <input type="text" class="form-control" id="documento"
                               name="documento" v-model="datoPersona.documento"
                               style="text-transform:uppercase" required>
                      </div>
                      <div class="col-1">
                        <button type="submit" class="btn btn-primary"
                                @click.prevent="consultarRC" title="Buscar registros">
                          <i class="material-icons" style="font-size:20px;color:white;cursor:pointer;">search</i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Localidad / Fecha Nac. -->
                  <div class="mb-3">
                    <input type="hidden" class="form-control" id="idLocalidad"
                           name="idLocalidad" v-model="datoPersona.idLocalidad" disabled>
                    <div class="row">
                      <div class="col-2">
                        <label for="idLocalidad" class="form-label">Localidad</label>
                      </div>
                      <div class="col-4">
                        <div class="input-group">
                          <input type="text" class="form-control"
                                 v-model="searchText" @input="filterLocalidades"
                                 placeholder="Buscar localidad...">
                          <button class="btn btn-outline-secondary dropdown-toggle"
                                  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa fa-search"></i>
                          </button>
                          <ul class="dropdown-menu dropdown-menu-end"
                              style="max-height:200px; overflow-y:auto;">
                            <li v-for="localidad in filteredLocalidades"
                                :key="localidad.idLocalidad">
                              <a class="dropdown-item" href="#"
                                 @click="selectLocalidad(localidad)">
                                {{ localidad.nombre }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-2">
                        <label for="fechaNac" class="form-label">Fecha Nac.</label>
                      </div>
                      <div class="col-4">
                        <input type="date" class="form-control" id="fechaNac"
                               name="fechaNac" v-model="formattedFechaNac" :max="maxDate">
                      </div>
                    </div>
                  </div>

                  <!-- Estado Civil / Teléfono -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="idEstadoCivil" class="form-label">Estado Civil</label>
                      </div>
                      <div class="col-4">
                        <select class="form-select" id="idEstadoCivil" name="idEstadoCivil"
                                v-model="datoPersona.idEstadoCivil" @change="handleChange02">
                          <option v-for="estadoCivil in estadosCiviles"
                                  :key="estadoCivil.idEstadoCivil"
                                  :value="estadoCivil.idEstadoCivil">
                            {{ estadoCivil.nombre }}
                          </option>
                        </select>
                      </div>
                      <div class="col-2">
                        <label for="telefono" class="form-label">Teléfono</label>
                      </div>
                      <div class="col-4">
                        <input type="text" class="form-control" id="telefono"
                               name="telefono" v-model="datoPersona.telefono" required>
                      </div>
                    </div>
                  </div>

                  <!-- Pri. Nombre / Seg. Nombre -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="primerNombre" class="form-label">Pri. Nombre</label>
                      </div>
                      <div class="col-4">
                        <input type="text" class="form-control" id="primerNombre"
                               name="primerNombre" v-model="datoPersona.primerNombre"
                               style="text-transform:uppercase" required>
                      </div>
                      <div class="col-2">
                        <label for="segundoNombre" class="form-label">Seg. Nombre</label>
                      </div>
                      <div class="col-4">
                        <input type="text" class="form-control" id="segundoNombre"
                               name="segundoNombre" v-model="datoPersona.segundoNombre"
                               style="text-transform:uppercase" required>
                      </div>
                    </div>
                  </div>

                  <!-- Pri. Apellido / Seg. Apellido -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="primerApellido" class="form-label">Pri. Apellido</label>
                      </div>
                      <div class="col-4">
                        <input type="text" class="form-control" id="primerApellido"
                               name="primerApellido" v-model="datoPersona.primerApellido"
                               style="text-transform:uppercase" required>
                      </div>
                      <div class="col-2">
                        <label for="segundoApellido" class="form-label">Seg. Apellido</label>
                      </div>
                      <div class="col-4">
                        <input type="text" class="form-control" id="segundoApellido"
                               name="segundoApellido" v-model="datoPersona.segundoApellido"
                               style="text-transform:uppercase" required>
                      </div>
                    </div>
                  </div>

                  <!-- Sexo y Tipo Sangre -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="sexo" class="form-label">Sexo</label>
                      </div>
                      <div class="col-4">
                        <select class="form-select" id="sexo" name="sexo"
                                v-model="datoPersona.sexo" required>
                          <option value="F">Femenino</option>
                          <option value="M">Masculino</option>
                        </select>
                      </div>
                      <div class="col-2">
                        <label for="idTipoSangre" class="form-label">Tipo sangre</label>
                      </div>
                      <div class="col-4">
                        <select class="form-select" id="idTipoSangre" name="idTipoSangre"
                                v-model="datoPersona.idTipoSangre">
                          <option v-for="tipoSangre in tiposSangre"
                                  :key="tipoSangre.idTipoSangre"
                                  :value="tipoSangre.idTipoSangre">
                            {{ tipoSangre.nombre }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Dirección -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="direccion" class="form-label">Dirección</label>
                      </div>
                      <div class="col-10">
                        <input type="text" class="form-control" id="direccion"
                               name="direccion" v-model="datoPersona.direccion"
                               style="text-transform:uppercase" required>
                      </div>
                    </div>
                  </div>

                  <!-- E-mail -->
                  <div class="mb-3">
                    <div class="row">
                      <div class="col-2">
                        <label for="email" class="form-label">E-mail</label>
                      </div>
                      <div class="col-10">
                        <input type="text" class="form-control" id="email"
                               name="email" v-model="datoPersona.email" required>
                      </div>
                    </div>
                  </div>


                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary"
                  @click.prevent="guardarPersona" v-if="btnCrear"
                  title="Continuar"
                  style="display:flex; align-items:center; justify-content:center;">
            Siguiente
            <span class="material-symbols-outlined"
                  style="font-size:32px; cursor:pointer; margin-left:8px;">
              chevron_right
            </span>
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout     from '@/components/Layout.vue'
import Footer     from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js'
import { validarPersona } from '@/modules/validarPersona.js'
import api        from '@/services/api'
import * as $     from 'jquery'
import { alertaError } from '@/utils/alertas'

window['$']      = $
window['jQuery'] = $

export default {
  components: { Layout, Footer },

  data() {
    return {
      personas:            [],
      datoPersona:         {},
      tipoIngreso:         'Agendamiento',
      nombreBusqueda:      '',
      titulo:              '',
      btnCrear:            true,
      btnEditar:           false,
      modalWindow:         true,
      p_idPersona:         0,
      showTable:           'mediopers',
      tiposIden:           [],
      estadosCiviles:      [],
      tiposSangre:         [],
      localidades:         [],
      filteredLocalidades: [],
      searchText:          '',
      maxDate:             new Date().toISOString().substr(0, 10),
      showModalHelp:       false,
      estiloImagen: {
        width:  '200px',
        height: '200px',
      },
    }
  },

  computed: {
    formattedFechaNac: {
      get() {
        if (!this.datoPersona.fechaNac) return ''
        const date  = new Date(this.datoPersona.fechaNac)
        const year  = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day   = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      set(value) {
        const date = new Date(value)
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
        this.datoPersona.fechaNac = date.toISOString()
      },
    },
  },

  mounted() {
    this.p_idPersona = this.$route.params.p_idpersona
    if (this.p_idPersona > 0) this.getData()

    const tipoGuardado = window.sessionStorage.getItem('tipoIngreso')
    if (tipoGuardado) this.tipoIngreso = tipoGuardado

    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchTiposIden()
    this.fetchEstadosCiviles()
    this.fetchLocalidades()
    this.fetchTiposSangre()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    getData() {
      api.get('/vwpersonas/' + this.p_idPersona)
        .then(response => {
          this.datoPersona = response.data
          this.searchText  = this.datoPersona.localidadNombre
        })
        .catch(error => console.error('Error al obtener datos de la persona:', error))
    },

    async guardarPersona() {
      this.datoPersona.estado = 1
      if (validarPersona(this.datoPersona)) {
        try {
          this.datoPersona.idEmpresa = window.sessionStorage.getItem('idEmpresa')
          await api.post('/personas', this.datoPersona).then(response => {
            this.personas               = response.data
            this.datoPersona.idPersona  = this.personas.idPersona
          })
        } catch (error) {
          if (error.response) {
            const errorMessage = error.response.data.message || 'Error desconocido al guardar la persona'
            alertaError(errorMessage)
          } else if (error.request) {
            alertaError('No se recibió respuesta del servidor.')
          } else {
            alertaError(error.message)
          }
          return
        }

        window.sessionStorage.setItem('tipoIngreso', this.tipoIngreso)

        this.$router.push('/pacientecita02/' + this.datoPersona.idPersona + '/0/0')
      }
    },

    fetchTiposIden() {
      api.get('/vwtipoidens')
        .then(response => { this.tiposIden = response.data })
        .catch(error => console.error('Error fetching tiposIden:', error))
    },

    fetchEstadosCiviles() {
      api.get('/vwestadocivils')
        .then(response => { this.estadosCiviles = response.data })
        .catch(error => console.error('Error fetching estados civiles:', error))
    },

    fetchTiposSangre() {
      api.get('/vwtiposangres')
        .then(response => { this.tiposSangre = response.data })
        .catch(error => console.error('Error fetching tipos sangre:', error))
    },

    fetchLocalidades() {
      api.get('/vwlocalidads')
        .then(response => {
          this.localidades         = response.data
          this.filteredLocalidades = response.data
        })
        .catch(error => console.error('Error fetching localidades:', error))
    },

    handleChange01() {
      this.$emit('tipoIdenSelected', this.selectedTipoIden)
    },

    handleChange02() {
      this.$emit('estadoCivilSelected', this.selectedEstadoCivil)
    },

    filterLocalidades() {
      this.filteredLocalidades = this.localidades.filter(localidad =>
        localidad.nombre.toLowerCase().includes(this.searchText.toLowerCase())
      )
    },

    selectLocalidad(localidad) {
      this.searchText              = localidad.nombre
      this.datoPersona.idLocalidad = localidad.idLocalidad
    },

    async consultarRC() {
      if (!this.datoPersona.documento?.trim()) {
        alertaError('Ingrese el número de documento para realizar la consulta.')
        return
      }
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      try {
        const response = await api.get('/vwpersonas/documento', {
          params: {
            documento: this.datoPersona.documento.trim(),
            idempresa: idEmpresa,
          },
        })
        const data    = response.data
        const persona = Array.isArray(data) ? data[0] : data
        if (persona) {
          this.datoPersona = { ...persona }
          this.searchText  = persona.localidadNombre ?? ''
          if (persona.fechaNac) {
            this.datoPersona.fechaNac = persona.fechaNac.slice(0, 10)
          }
        } else {
          this.asignarDatosEstaticos()
        }
      } catch (error) {
        console.warn('No se encontró en el endpoint, usando datos estáticos:', error)
        this.asignarDatosEstaticos()
      }
    },

    asignarDatosEstaticos() {
      this.searchText                 = 'AZUAY'
      this.datoPersona.idTipoIden     = 1
      this.datoPersona.idLocalidad    = 1
      this.datoPersona.idEstadoCivil  = 1
      this.datoPersona.primerNombre   = 'PRIMER NOMBRE'
      this.datoPersona.segundoNombre  = 'SEGUNDO NOMBRE'
      this.datoPersona.primerApellido = 'PRIMER APELLIDO'
      this.datoPersona.segundoApellido= 'SEGUNDO APELLIDO'
      this.datoPersona.fechaNac       = '2024-05-23'
      this.datoPersona.direccion      = 'DIRECCION'
      this.datoPersona.telefono       = '1234567890'
      this.datoPersona.tipoPersona    = 'N'
      this.datoPersona.sexo           = 'M'
      this.datoPersona.email          = 'paciente001@correo.com'
      this.datoPersona.fechaReg       = '2024-05-23'
      this.datoPersona.estado         = 1
    },
  },
}
</script>

<style>
.form-card {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
}
</style>